  function getContrastColor(hex) {
    // Expand shorthand form (e.g., "#f0f") to full form (e.g., "#ff00ff")
    if (hex.length === 4) {
      hex = "#" + [...hex.slice(1)].map((c) => c + c).join("");
    }

    // Convert to RGB
    const r = parseInt(hex.substr(1, 2), 16);
    const g = parseInt(hex.substr(3, 2), 16);
    const b = parseInt(hex.substr(5, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black or white text depending on luminance
    // return luminance > 0.5 ? "#000000" : "#ffffff";
    return luminance > 0.5 ? "#000000" : "#ffffff";
  }

function getContrastColorBackground(hex) {
    // Expand shorthand form (e.g., "#f0f") to full form (e.g., "#ff00ff")
    if (hex.length === 4) {
      hex = "#" + [...hex.slice(1)].map((c) => c + c).join("");
    }

    // Convert to RGB
    const r = parseInt(hex.substr(1, 2), 16);
    const g = parseInt(hex.substr(3, 2), 16);
    const b = parseInt(hex.substr(5, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black or white text depending on luminance
    return luminance > 0.5 ? "#000fff" : "#fff000";
  }

  function mixColors(color1, color2, weight = 0.5) {
    function hexToRgb(hex) {
      hex = hex.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
      }
      const num = parseInt(hex, 16);
      return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
    }

    function rgbToHex(r, g, b) {
      return (
        '#' +
        [r, g, b]
          .map(x => {
            const hex = x.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          })
          .join('')
      );
    }

    const rgb1 = hexToRgb(color1);
    const rgb2 = hexToRgb(color2);

    const mixed = rgb1.map((c, i) => Math.round(c * (1 - weight) + rgb2[i] * weight));

    return rgbToHex(...mixed);
  }

  export { getContrastColor, mixColors, getContrastColorBackground };